import { render, staticRenderFns } from "./PageVersion.vue?vue&type=template&id=c0269e8c&scoped=true"
import script from "./PageVersion.vue?vue&type=script&lang=js"
export * from "./PageVersion.vue?vue&type=script&lang=js"
import style0 from "./PageVersion.vue?vue&type=style&index=0&id=c0269e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0269e8c",
  null
  
)

export default component.exports